export default __webpack_public_path__ + "assets/webSite.fbfe72c7.png";